(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9307],{

/***/ 98716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85170);
/* harmony import */ var _Spacer_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90706);
/* harmony import */ var _Spacer_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Spacer_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Spacer = function(param1) {
    var _sizeMobile = param1.sizeMobile, sizeMobile = _sizeMobile === void 0 ? "0" : _sizeMobile, _sizeTablet = param1.sizeTablet, sizeTablet = _sizeTablet === void 0 ? "0" : _sizeTablet, _sizeDesktop = param1.sizeDesktop, sizeDesktop = _sizeDesktop === void 0 ? "0" : _sizeDesktop, _horizontal = param1.horizontal, horizontal = _horizontal === void 0 ? false : _horizontal, _top_border = param1.top_border, top_border1 = _top_border === void 0 ? "none" : _top_border;
    var getSpaceValue = function(spacer) {
        var spaceValue = spacer;
        if (spacer.includes("var") || spacer.includes("px")) {
            spaceValue = spacer;
        } else {
            spaceValue = "".concat(spacer, "px");
        }
        return spaceValue;
    };
    var nodeStyles = function(param) {
        var spacerSize = param.spacerSize, top_border = param.top_border;
        var spacerSizeValue = getSpaceValue(spacerSize);
        var _$styles = horizontal ? {
            height: "100%",
            width: "".concat(spacerSizeValue)
        } : {
            height: "".concat(spacerSizeValue),
            width: "100%"
        };
        if (top_border) {
            _$styles.borderTop = top_border;
        }
        return _$styles;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: nodeStyles({
                    spacerSize: sizeMobile,
                    top_border: top_border1
                }),
                className: (_Spacer_module_scss__WEBPACK_IMPORTED_MODULE_2___default().spacerMobile)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: nodeStyles({
                    spacerSize: sizeTablet,
                    top_border: top_border1
                }),
                className: (_Spacer_module_scss__WEBPACK_IMPORTED_MODULE_2___default().spacerTablet)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: nodeStyles({
                    spacerSize: sizeDesktop,
                    top_border: top_border1
                }),
                className: (_Spacer_module_scss__WEBPACK_IMPORTED_MODULE_2___default().spacerDesktop)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spacer);


/***/ }),

/***/ 69307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var _components_cms_Spacer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98716);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var SpacerWrapper = function(param) {
    var blok = param.blok;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cms_Spacer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({}, blok));
};
/* harmony default export */ __webpack_exports__["default"] = (SpacerWrapper);


/***/ }),

/***/ 90706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacerMobile":"Spacer_spacerMobile__16ktu","spacerTablet":"Spacer_spacerTablet__sf9pq","spacerDesktop":"Spacer_spacerDesktop__j2jku"};

/***/ })

}]);